import React, { createContext, useContext } from 'react';
import { BuyerRootStore } from './buyerRootStore';

const buyerStore = new BuyerRootStore();

const BuyerStoreContext = createContext<BuyerRootStore>(buyerStore);

export const BuyerStoreProvider = ({ children }: { children: React.ReactNode }) => (
  <BuyerStoreContext.Provider value={buyerStore}>{children}</BuyerStoreContext.Provider>
);

export const useBuyerStores = (): BuyerRootStore => useContext(BuyerStoreContext);
